import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sha256 } from 'js-sha256';
import { UtilityService } from '../../infrastructure/services/utils';
import useraction from '../../presentation/containers/app/userUseCase';

//Interface for the commonreducer state
interface InitialStateType {
  account: {
    name?: string;
    username?: string;
    homeAccountId?: string;
  };
  userInfo: {
    URL?: string;
    EYSubServiceLine?: string;
    EYSpecialityName?: string;
    EYServiceLine?: string;
    EYRank?: string;
    EYArea?: string;
    EYCountry?: string;
    userEmail?: string;
    sessionId: string;
    homeAccountId?: string;
  };
  token: string;
}

const initialState = {
  account: {},
  userInfo: {
    sessionId: UtilityService.generateGuid()
  },
  token: ''
} as InitialStateType;

/**
 * common reducer for handling all common state in the application
 */
const commonReducer = createSlice({
  name: 'general',
  initialState,
  reducers: {
    addAccountInfo(state: InitialStateType, action: PayloadAction<any>) {
      state.account = action.payload;
      let userDetails = JSON.parse(sessionStorage.getItem('UserInfo') || '{}');
      const hashedUserMailId = sha256(
        state.account.username ? state.account.username.toLowerCase() : ''
      ); // Hashing the User's mail id to compare with the Hashed User's mail Id in the Session storage.
      if (hashedUserMailId === userDetails.userEmail) {
        state.userInfo = userDetails;
      } else {
        sessionStorage.removeItem('UserInfo');
      }
    },
  // Setting up Access token
  setLoginAccessToken(state, action) {
    state.token = action.payload;
  }
  },  
  extraReducers: (builder) => {
    // builder.addCase(@param1:async function promise, @param2: call back handler function)
    builder.addCase(useraction.getUserInfo.fulfilled, (state, action) => {
      state.userInfo = {
        ...action.payload.results,
        userEmail: sha256(state.account.username ? state.account.username.toLowerCase() : ''), // Hashing the User's maild Id using SHA256 Library
        sessionId: state.userInfo.sessionId,
        homeAccountId: state.account.homeAccountId
      };
      sessionStorage.setItem('UserInfo', JSON.stringify(state.userInfo));
    });
    // added case to handle rejected scenario.
    builder.addCase(useraction.getUserInfo.rejected, (state, _action) => {
      state.userInfo = {
        sessionId: state.userInfo.sessionId
      };
    });

    // added case to handle pending scenario.
    builder.addCase(useraction.getUserInfo.pending, (state, _action) => {
      state.userInfo = {
        sessionId: state.userInfo.sessionId
      };
    });
  }
});

export const { addAccountInfo,setLoginAccessToken} = commonReducer.actions;
export default commonReducer.reducer;
